/**
 * Shared table components for RoutesNextPortTab and RoutesArrivalsTable.
 */
import React from 'react';
import { TableHead } from '@ais-ui/ui-core';
import { cn } from '@ais-ui/utils';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import type { DensityClasses } from './shared/popupDensityClasses';

export interface RoutesSortableHeadProps {
  column: string;
  children: React.ReactNode;
  currentColumn: string;
  ascending: boolean;
  onSort: (column: string) => void;
  densityClasses: DensityClasses;
}

export const SortableHead: React.FC<RoutesSortableHeadProps> = ({
  column,
  children,
  currentColumn,
  ascending,
  onSort,
  densityClasses,
}) => (
  <TableHead
    className={cn('cursor-pointer select-none', densityClasses.tableHeader)}
    onClick={() => onSort(column)}
  >
    <div className="flex items-center gap-1">
      <span className={densityClasses.text}>{children}</span>
      {currentColumn === column ? (
        ascending ? (
          <ArrowUp className={densityClasses.icon.small} />
        ) : (
          <ArrowDown className={densityClasses.icon.small} />
        )
      ) : (
        <ArrowUpDown className={cn(densityClasses.icon.small, 'opacity-50')} />
      )}
    </div>
  </TableHead>
);
